import { render, staticRenderFns } from "./SeparatorWhite.vue?vue&type=template&id=8c6a10fc&"
import script from "./SeparatorWhite.vue?vue&type=script&lang=js&"
export * from "./SeparatorWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports